/**
 * Kurzer Signalton fuer eine Anmahnung.
 *
 * Erzeugt statt abgespielt: keine Audiodatei, kein zusaetzlicher Pfad im
 * Service Worker, nichts an der CSP.
 *
 * **Verlaesslich ist dieser Ton nicht.** Browser lassen Audio erst zu, nachdem
 * auf der Seite etwas angetippt wurde — und der Empfaenger einer Anmahnung hat
 * genau das vielleicht seit Minuten nicht getan. Der Ton ist deshalb die
 * Zugabe; das Signal, auf das Verlass ist, ist die Push-Meldung, die das
 * Betriebssystem mit seinem eigenen Ton anzeigt.
 */

/** Zwei kurze Toene — als Aufforderung lesbar, ohne wie ein Fehler zu klingen. */
const BEEPS = [
  { frequency: 880, start: 0, duration: 0.12 },
  { frequency: 1174, start: 0.16, duration: 0.16 },
];

let context: AudioContext | null = null;

function audioContext(): AudioContext | null {
  if (context) return context;

  const Ctor = window.AudioContext ?? (window as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;

  context = new Ctor();
  return context;
}

export function playNudgeSound(): void {
  try {
    const ctx = audioContext();
    if (!ctx) return;

    // Nach einem Tab-Wechsel steht der Kontext oft auf „suspended". Das
    // Fortsetzen gelingt nur mit vorheriger Interaktion — schlaegt es fehl,
    // bleibt es beim stillen Hinweis.
    if (ctx.state === 'suspended') void ctx.resume().catch(() => undefined);

    const now = ctx.currentTime;

    for (const beep of BEEPS) {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();

      oscillator.type = 'sine';
      oscillator.frequency.value = beep.frequency;

      /*
       * Ein- und ausblenden statt hart schalten: ein Rechtecksprung im Pegel
       * knackt hoerbar, und zwar genau auf den kleinen Lautsprechern, um die
       * es hier geht.
       */
      const start = now + beep.start;
      const end = start + beep.duration;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.18, start + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, end);

      oscillator.connect(gain).connect(ctx.destination);
      oscillator.start(start);
      oscillator.stop(end + 0.02);
    }
  } catch {
    // Ton ist eine Zugabe. Ein Browser, der ihn verweigert, darf den Hinweis
    // nicht mitreissen.
  }
}
